import { render, staticRenderFns } from "./TmplOverview.vue?vue&type=template&id=2c448e72&scoped=true"
import script from "./TmplOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./TmplOverview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TmplOverview.vue?vue&type=style&index=0&id=2c448e72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c448e72",
  null
  
)

export default component.exports